import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useLazyCopyToClipboard from "hooks/useLazyCopyToClipboard";
import useTypedContext from "hooks/useTypedContext";
import useChatConversationTranscript from "shared/ChatConversation/useChatConversationTranscript";

const useAssistantPanelChatCopyTranscript = (chatId: string | undefined) => {
  const { reportError, onError } = useTypedContext(FlashContext);
  const copyToClipboard = useLazyCopyToClipboard();
  const { loadTranscript, loading } = useChatConversationTranscript();

  const copyTranscript = useCallback(() => {
    if (!chatId) {
      return;
    }

    loadTranscript(chatId).then((transcript) => {
      if (transcript === undefined) {
        reportError({ message: "Could not copy to clipboard" });
        return;
      }

      copyToClipboard(transcript);
    }, onError);
  }, [chatId, loadTranscript, copyToClipboard, reportError, onError]);

  return { copyTranscript, loading };
};

export default useAssistantPanelChatCopyTranscript;
